// AddItemsForm.jsx
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ManualAddItemGrid from '../AddItems/ManualAddItemGrid';

export const AddItemsForm = ({ onSave, onCancel }) => {
    const [mode, setMode] = useState('options'); // 'options', 'manual', 'csv'

    // Render the manual entry grid when mode is 'manual'
    if (mode === 'manual') {
        return <ManualAddItemGrid onSave={onSave} onCancel={onCancel} />;
    }

    // Placeholder for future CSV functionality
    if (mode === 'csv') {
        return (
            <Box sx={{ p: 3 }}>
                <Typography>CSV Upload functionality is not yet implemented.</Typography>
                <Button onClick={() => setMode('options')} sx={{ mt: 2 }}>
                    Back
                </Button>
            </Box>
        );
    }

    // Render the initial choice buttons
    return (
        <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
            <Typography variant="h6">How would you like to add items?</Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
                <Button variant="outlined" size="large" onClick={() => setMode('manual')}>
                    Manual
                </Button>
                <Button variant="outlined" size="large" onClick={() => setMode('csv')}>
                    CSV Files
                </Button>
            </Box>
        </Box>
    );
};

export default AddItemsForm;